export const visit = (vm, at) => {
vm(require("calling-orchestration-shared-library/lang/alert-store/en.lyaml"));
vm(require("external-sharing-components/lang/en.lyaml"));
vm(require("file-manager-components/lang/en.lyaml"));
vm(require("foundations-components/lang/en.lyaml"));
vm(require("object-comments-thread-lib/lang/en.lyaml"));
vm(require("prosemirror-user-and-team-at-mentions/lang/en.lyaml"));
vm(require("purchase-motions-components/lang/en.lyaml"));
vm(require("react-colorpicker/lang/en.lyaml"));
vm(require("recording-review-components-lib/lang/en.lyaml"));
vm(require("ui-addon-upgrades/lang/en.lyaml"));
vm(require("video-components-external/lang/en.lyaml"));
vm(require("ui-addon-upgrades/lang/featureTable/en.lyaml"));
vm(require("ui-addon-upgrades/lang/featureTableMC0672/en.lyaml"));
vm(require("ui-addon-upgrades/lang/upgradePointTooltip/en.lyaml"));
vm(require("ui-addon-upgrades/lang/usageLimitCounter/en.lyaml"));
vm(require("ui-addon-upgrades/lang/valuePropModals/en.lyaml"));
at({ "en": { "universal-recording-review-public-ui": { "app": { "htmlTitle": "HubSpot Recording" }, "routes": { "placeholder": "Coming soon" }, "error": { "title": "This recording is unavailable", "invalid": "The link you followed is invalid or does not exist.", "expired": "This shared recording link has expired.", "revoked": "Access to this recording has been revoked." } } } });
};